import { ApiError } from './api';

/** Map an error to a localised message key. */
export function errorKey(err: unknown): string {
  if (err instanceof ApiError) {
    if (err.isNetwork) return 'err.network';
    return `err.${err.code}`;
  }
  return 'err.generic';
}
